var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("main", { attrs: { id: "page-wrap" } }),
    _vm._v(" "),
    !_vm.renderComponent
      ? _c("div", { staticClass: "overlay show" }, [_vm._m(0)])
      : _c(
          "div",
          { attrs: { id: _vm.$route.query.lang } },
          [
            _vm.$route.query.lang == "ar" || _vm.$route.query.language == "ar"
              ? _c("arStyles")
              : _vm._e(),
            _vm._v(" "),
            _c("headerTop", {
              on: {
                forceRerender: function($event) {
                  _vm.forceRerender($event)
                },
                showLoader: function($event) {
                  _vm.showLoader($event)
                }
              }
            }),
            _vm._v(" "),
            _vm.$route.meta.layout == "student"
              ? _c("studentLayout")
              : _vm._e(),
            _vm._v(" "),
            _vm.$route.meta.layout == "parent" ? _c("parentLayout") : _vm._e(),
            _vm._v(" "),
            _vm.$route.meta.layout == "teacher"
              ? _c("teacherLayout")
              : _vm._e(),
            _vm._v(" "),
            _vm.$route.meta.layout == "school" ? _c("schoolLayout") : _vm._e(),
            _vm._v(" "),
            _vm.$route.meta.layout == "admin" ? _c("adminLayout") : _vm._e(),
            _vm._v(" "),
            _vm.$route.meta.layout == "game" ? _c("gameLayout") : _vm._e(),
            _vm._v(" "),
            _vm.$route.meta.layout == "guest" ? _c("guestLayout") : _vm._e()
          ],
          1
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "loading-spinner" } }, [
      _c("div", { staticClass: "spin-icon" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 